import { combineReducers } from "redux";
import loginReducer from "./auth/login/reducer";
import lastRouteReducer from "./routes/reducer";
// import GetUploadFilesReducer from "./UploadFiles/reducer";
// import GetUploadFilesIDReducer from "./UploadFiles/UploadDetails/reducer";
import { authReducer } from "./auth/reducer";
import { inventoryReducer } from "./inventory/reducer";
import financeReducer from "./finance/financeSlice";

export const rootReducer = combineReducers({
  auth: authReducer,
  login: loginReducer,
  lastRoute: lastRouteReducer,
  inventory: inventoryReducer,
  finance: financeReducer,
  // getUploads: GetUploadFilesReducer,
  // getUploadsById: GetUploadFilesIDReducer,
});
